import axiosInstance from '../../../../services/api';

const BULK_INITIALIZE_API_ENDPOINT = '/api/commercial-products/bulk-initialize/';

/**
 * Normalize an array of IDs - ensures each ID is separate (splits comma-separated strings)
 * @param {Array} arr - Array that may contain comma-separated strings
 * @returns {Array<string>} - Array of individual IDs
 */
const normalizeIdArray = (arr) => {
  if (!arr || !Array.isArray(arr)) return [];

  return arr.flatMap((item) => {
    if (typeof item === 'string' && item.includes(',')) {
      return item.split(',').map((id) => id.trim()).filter(Boolean);
    }
    return item;
  }).filter(Boolean);
};

/**
 * Service for commercial product bulk initialization API
 * Fetches labels for IDs when restoring URL state (cold start)
 */
export const ProductBulkInitializeService = {
  /**
   * Bulk fetch labels for product URL state restoration
   * @param {Object} ids - Object containing arrays of IDs to fetch
   * @returns {Promise<Object>} Labels for all provided IDs
   */
  async bulkInitialize(ids) {
    try {
      const { data } = await axiosInstance.post(BULK_INITIALIZE_API_ENDPOINT, {
        culture_ids: normalizeIdArray(ids.culture_ids),
        cultural_practice_ids: normalizeIdArray(ids.cultural_practice_ids),
        enemy_ids: normalizeIdArray(ids.enemy_ids),
        activity_sector_ids: normalizeIdArray(ids.activity_sector_ids),
        product_type_ids: normalizeIdArray(ids.product_type_ids),
        chemical_family_ids: normalizeIdArray(ids.chemical_family_ids),
        pesticide_group_ids: normalizeIdArray(ids.pesticide_group_ids),
        pesticide_category_ids: normalizeIdArray(ids.pesticide_category_ids),
        activity_type_ids: normalizeIdArray(ids.activity_type_ids),
        arla_culture_group_ids: normalizeIdArray(ids.arla_culture_group_ids),
        application_type_ids: normalizeIdArray(ids.application_type_ids),
        allergen_ids: normalizeIdArray(ids.allergen_ids),
      });
      return data;
    } catch (error) {
      console.error('[ProductBulkInitialize] API error:', error);
      throw error;
    }
  },
};

export default ProductBulkInitializeService;
